/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleaseverifyemailfirst3Inputs */

const en_pleaseverifyemailfirst3 = /** @type {(inputs: Pleaseverifyemailfirst3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please verify your email first.`)
};

const de_pleaseverifyemailfirst3 = /** @type {(inputs: Pleaseverifyemailfirst3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte bestätige zuerst deine E-Mail-Adresse.`)
};

/**
* | output |
* | --- |
* | "Please verify your email first." |
*
* @param {Pleaseverifyemailfirst3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleaseverifyemailfirst3 = /** @type {((inputs?: Pleaseverifyemailfirst3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleaseverifyemailfirst3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleaseverifyemailfirst3(inputs)
	return de_pleaseverifyemailfirst3(inputs)
});
export { pleaseverifyemailfirst3 as "pleaseVerifyEmailFirst" }